import React from 'react';
import { FieldProps } from '../../types';
import { PhoneNumberFieldV2 } from './PhoneNumberFieldV2';

export const EmergencyContactNumberField: React.FC<FieldProps> = ({ margin = undefined }) => {
  return (
    <PhoneNumberFieldV2
      rules={{}}
      label="Emergency Contact Number"
      margin={margin}
      name="emergency_contact_number"
    />
  );
};
